// Mock data for Leci123 landing page

export const content = {
  id: {
    // Indonesian content
    hero: {
      title: "LECI123",
      subtitle: "Situs Platform Slot Online Terbaik & Terpercaya di Indonesia",
      cta: {
        register: "DAFTAR",
        login: "LOGIN"
      }
    },
    welcome: {
      title: "Selamat Datang di LECI123",
      description: "Selamat datang di LECI123, situs platform slot online terpercaya yang dirancang khusus untuk pemain Indonesia yang ingin menikmati pengalaman bermain yang aman, menyenangkan, dan penuh peluang kemenangan. Di LECI123, kami tidak hanya sekadar menjadi platform judi online biasa. Kami adalah tempat berkumpulnya pecinta game slot dari seluruh penjuru negeri yang mencari permainan berkualitas dengan sistem yang adil dan transparan."
    },
    features: {
      title: "Mengapa Memilih LECI123?",
      items: [
        {
          title: "Fokus pada Slot Online Terpercaya",
          description: "Kami memprioritaskan slot online dengan provider ternama seperti Pragmatic Play, PG Soft, Habanero, Spadegaming, dan Joker Gaming. Game dengan RTP tinggi dan visual menarik.",
          icon: "gamepad2"
        },
        {
          title: "Sistem Keamanan Terjamin",
          description: "Menggunakan enkripsi SSL terbaru, sistem anti-bot dan anti-phising untuk menjaga setiap data transaksi Anda tetap aman dan terlindungi.",
          icon: "shield"
        },
        {
          title: "RTP Transparan & Gampang Menang",
          description: "Informasi RTP disediakan untuk setiap game. Mainkan Gates of Olympus, Starlight Princess, Mahjong Ways, Sweet Bonanza, dan game populer lainnya.",
          icon: "trophy"
        },
        {
          title: "Proses Daftar Cepat & Mudah",
          description: "Bergabung hanya butuh waktu kurang dari 2 menit. Dukungan berbagai metode pembayaran: Transfer Bank (BCA, BRI, Mandiri, BNI), E-wallet (OVO, DANA, GoPay), dan QRIS.",
          icon: "zap"
        }
      ]
    },
    games: {
      title: "Game Populer",
      items: [
        "Gates of Olympus",
        "Starlight Princess",
        "Mahjong Ways",
        "Sweet Bonanza",
        "Great Rhino Megaways",
        "Aztec Gems"
      ]
    },
    security: {
      title: "Keamanan & Fairplay",
      description: "Kami menyadari bahwa keamanan adalah hal paling krusial di dunia judi online. LECI123 menggunakan sistem enkripsi SSL terbaru untuk menjaga setiap data transaksi Anda tetap aman.",
      features: [
        "Enkripsi SSL 256-bit",
        "Sistem Anti-Bot",
        "Anti-Phising Protection",
        "Fair Play Guarantee",
        "Verifikasi Dua Faktor"
      ]
    },
    support: {
      title: "Layanan Pelanggan Profesional 24/7",
      description: "Tim Customer Service kami siap membantu kapan saja, 24 jam setiap hari, termasuk hari libur. Kami percaya bahwa pelayanan yang cepat dan sopan adalah bagian dari pengalaman bermain yang berkualitas.",
      channels: [
        { name: "Live Chat", icon: "messageCircle", available: true },
        { name: "WhatsApp", icon: "phone", available: true },
        { name: "Telegram", icon: "send", available: true }
      ]
    },
    warning: {
      title: "Waspada Phising – Akses Hanya Situs Resmi",
      description: "Pastikan Anda hanya mengakses situs resmi kami. Jangan klik link dari chat pribadi yang tidak resmi, iklan mencurigakan, atau grup tidak resmi."
    },
    footer: {
      copyright: "© 2025 LECI123. Semua hak dilindungi.",
      description: "LECI123 adalah platform slot online terpercaya di Indonesia dengan sistem keamanan terbaik dan peluang menang besar."
    }
  },
  en: {
    // English content
    hero: {
      title: "LECI123",
      subtitle: "Best & Most Trusted Online Slot Platform in Indonesia",
      cta: {
        register: "REGISTER",
        login: "LOGIN"
      }
    },
    welcome: {
      title: "Welcome to LECI123",
      description: "Welcome to LECI123, a trusted online slot platform designed specifically for Indonesian players who want to enjoy a safe, fun, and winning gaming experience. At LECI123, we are not just an ordinary online gaming platform. We are a gathering place for slot game lovers from all over the country looking for quality games with a fair and transparent system."
    },
    features: {
      title: "Why Choose LECI123?",
      items: [
        {
          title: "Focus on Trusted Online Slots",
          description: "We prioritize online slots with renowned providers such as Pragmatic Play, PG Soft, Habanero, Spadegaming, and Joker Gaming. Games with high RTP and attractive visuals.",
          icon: "gamepad2"
        },
        {
          title: "Guaranteed Security System",
          description: "Using the latest SSL encryption, anti-bot and anti-phishing systems to keep all your transaction data safe and protected.",
          icon: "shield"
        },
        {
          title: "Transparent RTP & Easy to Win",
          description: "RTP information provided for each game. Play Gates of Olympus, Starlight Princess, Mahjong Ways, Sweet Bonanza, and other popular games.",
          icon: "trophy"
        },
        {
          title: "Quick & Easy Registration",
          description: "Join in less than 2 minutes. Support for various payment methods: Bank Transfer (BCA, BRI, Mandiri, BNI), E-wallet (OVO, DANA, GoPay), and QRIS.",
          icon: "zap"
        }
      ]
    },
    games: {
      title: "Popular Games",
      items: [
        "Gates of Olympus",
        "Starlight Princess",
        "Mahjong Ways",
        "Sweet Bonanza",
        "Great Rhino Megaways",
        "Aztec Gems"
      ]
    },
    security: {
      title: "Security & Fairplay",
      description: "We realize that security is the most crucial thing in the online gambling world. LECI123 uses the latest SSL encryption system to keep all your transaction data safe.",
      features: [
        "256-bit SSL Encryption",
        "Anti-Bot System",
        "Anti-Phishing Protection",
        "Fair Play Guarantee",
        "Two-Factor Authentication"
      ]
    },
    support: {
      title: "Professional 24/7 Customer Service",
      description: "Our Customer Service team is ready to help anytime, 24 hours a day, including holidays. We believe that fast and polite service is part of a quality gaming experience.",
      channels: [
        { name: "Live Chat", icon: "messageCircle", available: true },
        { name: "WhatsApp", icon: "phone", available: true },
        { name: "Telegram", icon: "send", available: true }
      ]
    },
    warning: {
      title: "Beware of Phishing – Access Official Site Only",
      description: "Make sure you only access our official site. Don't click links from unofficial private chats, suspicious ads, or unofficial groups."
    },
    footer: {
      copyright: "© 2025 LECI123. All rights reserved.",
      description: "LECI123 is a trusted online slot platform in Indonesia with the best security system and great winning opportunities."
    }
  }
};

export const providers = [
  { name: "Pragmatic Play", logo: "🎮" },
  { name: "PG Soft", logo: "🎲" },
  { name: "Habanero", logo: "🌶️" },
  { name: "Spadegaming", logo: "♠️" },
  { name: "Joker Gaming", logo: "🃏" }
];

export const paymentMethods = [
  { name: "BCA", type: "bank" },
  { name: "BRI", type: "bank" },
  { name: "Mandiri", type: "bank" },
  { name: "BNI", type: "bank" },
  { name: "OVO", type: "ewallet" },
  { name: "DANA", type: "ewallet" },
  { name: "GoPay", type: "ewallet" },
  { name: "QRIS", type: "qris" }
];

export const socialMedia = {
  instagram: "https://instagram.com/leci123.website"
};

// SEO: Step-by-step guides (for HowTo schema + cluster keyword coverage)
export const howToGuides = {
  id: {
    daftar: {
      title: "Cara Daftar LECI123 (Hanya 2 Menit)",
      description: "Panduan lengkap mendaftar akun LECI123 dengan cepat dan aman",
      totalTime: "PT2M",
      steps: [
        { name: "Buka Link Resmi", text: "Akses link resmi LECI123 melalui browser favorit Anda." },
        { name: "Klik Tombol Daftar", text: "Klik tombol DAFTAR berwarna oranye di pojok kanan atas." },
        { name: "Isi Data Diri", text: "Isi username, password, email, nomor HP, dan rekening bank Anda." },
        { name: "Verifikasi Akun", text: "Konfirmasi data Anda dan akun LECI123 langsung aktif siap digunakan." }
      ],
      url: "https://x500.cc/daftar-leci123"
    },
    login: {
      title: "Cara Login LECI123",
      description: "Panduan login ke akun LECI123 dengan aman",
      totalTime: "PT1M",
      steps: [
        { name: "Akses Link Resmi", text: "Buka link resmi LECI123 untuk menghindari situs phising." },
        { name: "Klik Tombol Login", text: "Klik tombol LOGIN di pojok kanan atas halaman." },
        { name: "Masukkan Username & Password", text: "Isi username dan password akun LECI123 Anda." },
        { name: "Mulai Bermain", text: "Setelah login berhasil, Anda dapat langsung memilih game slot favorit." }
      ],
      url: "https://x500.cc/login-leci123"
    },
    deposit: {
      title: "Cara Deposit LECI123",
      description: "Panduan deposit di LECI123 via Bank, E-wallet, dan QRIS",
      totalTime: "PT3M",
      steps: [
        { name: "Login ke Akun", text: "Login ke akun LECI123 Anda terlebih dahulu." },
        { name: "Pilih Menu Deposit", text: "Klik menu DEPOSIT di dashboard akun." },
        { name: "Pilih Metode Pembayaran", text: "Pilih BCA, BRI, Mandiri, BNI, OVO, DANA, GoPay, atau QRIS." },
        { name: "Transfer & Konfirmasi", text: "Transfer sesuai nominal dan upload bukti pembayaran." },
        { name: "Saldo Masuk", text: "Saldo akan masuk dalam 1-3 menit dan siap digunakan." }
      ]
    }
  },
  en: {
    daftar: {
      title: "How to Register LECI123 (Only 2 Minutes)",
      description: "Complete guide to register LECI123 account quickly and safely",
      totalTime: "PT2M",
      steps: [
        { name: "Open Official Link", text: "Access the official LECI123 link through your favorite browser." },
        { name: "Click Register Button", text: "Click the orange REGISTER button at the top right corner." },
        { name: "Fill Personal Data", text: "Fill in username, password, email, phone number, and bank account." },
        { name: "Verify Account", text: "Confirm your data and your LECI123 account is ready to use." }
      ],
      url: "https://x500.cc/daftar-leci123"
    },
    login: {
      title: "How to Login LECI123",
      description: "Guide to safely login to your LECI123 account",
      totalTime: "PT1M",
      steps: [
        { name: "Access Official Link", text: "Open the official LECI123 link to avoid phishing sites." },
        { name: "Click Login Button", text: "Click the LOGIN button at the top right corner." },
        { name: "Enter Credentials", text: "Fill in your LECI123 account username and password." },
        { name: "Start Playing", text: "After successful login, you can immediately choose your favorite slot." }
      ],
      url: "https://x500.cc/login-leci123"
    },
    deposit: {
      title: "How to Deposit at LECI123",
      description: "Deposit guide at LECI123 via Bank, E-wallet, and QRIS",
      totalTime: "PT3M",
      steps: [
        { name: "Login to Account", text: "Login to your LECI123 account first." },
        { name: "Select Deposit Menu", text: "Click the DEPOSIT menu in the account dashboard." },
        { name: "Choose Payment Method", text: "Select BCA, BRI, Mandiri, BNI, OVO, DANA, GoPay, or QRIS." },
        { name: "Transfer & Confirm", text: "Transfer the amount and upload payment proof." },
        { name: "Balance Credited", text: "Balance will be credited within 1-3 minutes and ready to use." }
      ]
    }
  }
};

// SEO: FAQ data for FAQPage schema (featured snippet eligibility)
export const faqData = {
  id: {
    title: "Pertanyaan yang Sering Diajukan tentang LECI123",
    items: [
      {
        question: "Apa itu LECI123?",
        answer: "LECI123 adalah situs platform slot online terpercaya di Indonesia yang menyediakan ratusan game slot dari provider ternama seperti Pragmatic Play, PG Soft, Habanero, dan lainnya dengan RTP tinggi dan sistem fair play."
      },
      {
        question: "Apakah LECI123 aman dan terpercaya?",
        answer: "Ya, LECI123 menggunakan enkripsi SSL 256-bit, sistem anti-phising, dan verifikasi dua faktor untuk menjamin keamanan data dan transaksi Anda. Sudah dipercaya oleh lebih dari 12.000 member aktif di Indonesia."
      },
      {
        question: "Berapa lama proses daftar LECI123?",
        answer: "Proses pendaftaran LECI123 hanya membutuhkan waktu kurang dari 2 menit. Anda hanya perlu mengisi username, password, email, nomor HP, dan rekening bank."
      },
      {
        question: "Bagaimana cara login LECI123 jika domain diblokir?",
        answer: "Jika domain utama LECI123 diblokir oleh Nawala atau ISP, Anda dapat menggunakan link alternatif resmi yang selalu kami update. Pastikan hanya mengakses link dari sumber resmi untuk menghindari phising."
      },
      {
        question: "Apakah LECI123 menyediakan aplikasi APK?",
        answer: "Ya, LECI123 menyediakan aplikasi APK untuk Android yang dapat diunduh langsung dari situs resmi. Aplikasi ini lebih ringan, hemat data, dan tetap aman seperti versi web."
      },
      {
        question: "Metode pembayaran apa saja yang didukung LECI123?",
        answer: "LECI123 mendukung transfer bank lokal (BCA, BRI, Mandiri, BNI), e-wallet (OVO, DANA, GoPay), dan QRIS untuk kemudahan deposit dan withdraw."
      },
      {
        question: "Berapa minimal deposit di LECI123?",
        answer: "Minimal deposit di LECI123 sangat terjangkau, mulai dari Rp 10.000 saja. Proses deposit cepat dalam 1-3 menit setelah konfirmasi pembayaran."
      },
      {
        question: "Berapa lama proses withdraw LECI123?",
        answer: "Proses withdraw di LECI123 sangat cepat, rata-rata hanya 3-5 menit untuk transfer ke rekening bank atau e-wallet Anda, tergantung jam operasional bank."
      },
      {
        question: "Apa game slot paling populer di LECI123?",
        answer: "Game slot terpopuler di LECI123 antara lain Gates of Olympus, Sweet Bonanza, Starlight Princess, Mahjong Ways, Great Rhino Megaways, dan Aztec Gems dengan RTP rata-rata 96-97%."
      },
      {
        question: "Apakah ada bonus untuk member baru LECI123?",
        answer: "Ya, LECI123 menyediakan bonus selamat datang (welcome bonus) untuk member baru, bonus deposit harian, cashback mingguan, dan promo spesial lainnya yang dapat dilihat di halaman promosi."
      }
    ]
  },
  en: {
    title: "Frequently Asked Questions about LECI123",
    items: [
      {
        question: "What is LECI123?",
        answer: "LECI123 is a trusted online slot platform site in Indonesia that provides hundreds of slot games from renowned providers such as Pragmatic Play, PG Soft, Habanero, and others with high RTP and a fair play system."
      },
      {
        question: "Is LECI123 safe and trustworthy?",
        answer: "Yes, LECI123 uses 256-bit SSL encryption, anti-phishing system, and two-factor authentication to guarantee the security of your data and transactions. Trusted by more than 12,000 active members in Indonesia."
      },
      {
        question: "How long does the LECI123 registration process take?",
        answer: "The LECI123 registration process only takes less than 2 minutes. You only need to fill in username, password, email, phone number, and bank account."
      },
      {
        question: "How to login LECI123 if the domain is blocked?",
        answer: "If the main LECI123 domain is blocked by Nawala or ISP, you can use the official alternative link that we always update. Make sure to only access links from official sources to avoid phishing."
      },
      {
        question: "Does LECI123 provide an APK app?",
        answer: "Yes, LECI123 provides an APK application for Android that can be downloaded directly from the official site. This app is lighter, data-saving, and equally safe as the web version."
      },
      {
        question: "What payment methods does LECI123 support?",
        answer: "LECI123 supports local bank transfers (BCA, BRI, Mandiri, BNI), e-wallets (OVO, DANA, GoPay), and QRIS for easy deposit and withdrawal."
      },
      {
        question: "What is the minimum deposit at LECI123?",
        answer: "The minimum deposit at LECI123 is very affordable, starting from only Rp 10,000. The deposit process is fast within 1-3 minutes after payment confirmation."
      },
      {
        question: "How long does the LECI123 withdraw process take?",
        answer: "The withdraw process at LECI123 is very fast, on average only 3-5 minutes to transfer to your bank account or e-wallet, depending on bank operational hours."
      },
      {
        question: "What are the most popular slot games at LECI123?",
        answer: "The most popular slot games at LECI123 include Gates of Olympus, Sweet Bonanza, Starlight Princess, Mahjong Ways, Great Rhino Megaways, and Aztec Gems with an average RTP of 96-97%."
      },
      {
        question: "Are there bonuses for new LECI123 members?",
        answer: "Yes, LECI123 provides welcome bonuses for new members, daily deposit bonuses, weekly cashback, and other special promos that can be seen on the promotions page."
      }
    ]
  }
};

// SEO: RTP Live data (signals freshness + transactional intent)
export const rtpLive = {
  id: {
    title: "RTP Live Slot LECI123 Hari Ini",
    subtitle: "Update terbaru bocoran RTP slot gacor LECI123 — diperbarui setiap jam",
    games: [
      { name: "Gates of Olympus", rtp: 97.34, status: "GACOR" },
      { name: "Sweet Bonanza", rtp: 96.85, status: "GACOR" },
      { name: "Starlight Princess", rtp: 95.22, status: "WARM" },
      { name: "Mahjong Ways", rtp: 97.62, status: "GACOR" },
      { name: "Great Rhino Megaways", rtp: 94.51, status: "WARM" },
      { name: "Aztec Gems", rtp: 92.18, status: "COOL" }
    ]
  },
  en: {
    title: "LECI123 Live Slot RTP Today",
    subtitle: "Latest RTP leaks for LECI123 hot slots — updated every hour",
    games: [
      { name: "Gates of Olympus", rtp: 97.34, status: "HOT" },
      { name: "Sweet Bonanza", rtp: 96.85, status: "HOT" },
      { name: "Starlight Princess", rtp: 95.22, status: "WARM" },
      { name: "Mahjong Ways", rtp: 97.62, status: "HOT" },
      { name: "Great Rhino Megaways", rtp: 94.51, status: "WARM" },
      { name: "Aztec Gems", rtp: 92.18, status: "COOL" }
    ]
  }
};

// SEO: Promo/Bonus section (transactional value-add)
export const promos = {
  id: {
    title: "Bonus & Promo LECI123 Terbaru",
    items: [
      { name: "Welcome Bonus 100%", desc: "Bonus deposit pertama hingga 100% untuk member baru" },
      { name: "Cashback Mingguan 10%", desc: "Cashback otomatis setiap Senin untuk semua member aktif" },
      { name: "Bonus Referral 5%", desc: "Ajak teman daftar dan dapatkan komisi seumur hidup" },
      { name: "Bonus Rollingan 0.8%", desc: "Bonus turnover slot mingguan untuk semua game" }
    ]
  },
  en: {
    title: "LECI123 Latest Bonuses & Promos",
    items: [
      { name: "Welcome Bonus 100%", desc: "First deposit bonus up to 100% for new members" },
      { name: "Weekly Cashback 10%", desc: "Automatic cashback every Monday for all active members" },
      { name: "Referral Bonus 5%", desc: "Invite friends to register and earn lifetime commission" },
      { name: "Rolling Bonus 0.8%", desc: "Weekly slot turnover bonus for all games" }
    ]
  }
};

export const gameGallery = [
  {
    name: "Gates of Olympus",
    image: "https://customer-assets.emergentagent.com/job_leci-community/artifacts/vptpfryi_gateofolympus.jpg",
    alt: "Gates of Olympus - Game Slot LECI123 dengan RTP tinggi",
    rtp: "96.50%"
  },
  {
    name: "Sweet Bonanza",
    image: "https://customer-assets.emergentagent.com/job_leci-community/artifacts/k5qoarua_sweetbonanza.jpg",
    alt: "Sweet Bonanza - Slot Online Gampang Menang LECI123",
    rtp: "96.51%"
  },
  {
    name: "Starlight Princess",
    image: "https://customer-assets.emergentagent.com/job_leci-community/artifacts/0h45sf3l_starlightprincess.jpg",
    alt: "Starlight Princess - Slot Pragmatic Play LECI123",
    rtp: "96.50%"
  },
  {
    name: "Mahjong Ways",
    image: "https://customer-assets.emergentagent.com/job_leci-community/artifacts/1648wbdl_mahjongways.jpg",
    alt: "Mahjong Ways - PG Soft Slot LECI123",
    rtp: "96.95%"
  },
  {
    name: "Great Rhino Megaways",
    image: "https://customer-assets.emergentagent.com/job_leci-community/artifacts/bibysh0j_greatrhinomegaways.jpg",
    alt: "Great Rhino Megaways - Slot Pragmatic LECI123",
    rtp: "96.58%"
  },
  {
    name: "Aztec Gems",
    image: "https://customer-assets.emergentagent.com/job_leci-community/artifacts/wigziit3_aztecgems.jpg",
    alt: "Aztec Gems Megaways - Slot Klasik LECI123",
    rtp: "96.52%"
  }
];

export const reviews = {
  id: {
    title: "Apa Kata Pemain Kami",
    subtitle: "Ribuan member puas dengan layanan LECI123",
    aggregateRating: {
      ratingValue: 4.9,
      reviewCount: 12847,
      bestRating: 5,
      worstRating: 1
    },
    items: [
      {
        name: "Budi Santoso",
        location: "Jakarta",
        rating: 5,
        date: "2 hari yang lalu",
        comment: "Withdraw cepat banget, baru 3 menit udah masuk rekening BCA. Bermain di LECI123 emang nyaman, customer service-nya juga ramah dan responsif.",
        verified: true
      },
      {
        name: "Andi Pratama",
        location: "Surabaya",
        rating: 5,
        date: "1 minggu yang lalu",
        comment: "Sudah hampir 1 tahun main di LECI123, belum pernah ada masalah. RTP-nya tinggi, jackpot Gates of Olympus saya tembus 250 juta. Terima kasih LECI123!",
        verified: true
      },
      {
        name: "Sari Wulandari",
        location: "Bandung",
        rating: 5,
        date: "3 hari yang lalu",
        comment: "Awalnya ragu coba main slot online, tapi LECI123 ternyata terpercaya. Deposit via DANA langsung masuk, gak ribet. Bonus newbie-nya juga lumayan.",
        verified: true
      },
      {
        name: "Rizki Hidayat",
        location: "Medan",
        rating: 4,
        date: "5 hari yang lalu",
        comment: "Permainannya banyak pilihan, dari Pragmatic, PG Soft sampai Habanero ada semua. Live chat-nya 24 jam ngebantu banget pas malam-malam.",
        verified: true
      },
      {
        name: "Dewi Lestari",
        location: "Yogyakarta",
        rating: 5,
        date: "1 minggu yang lalu",
        comment: "Suka banget sama tampilan LECI123, simpel dan gampang dipake. Daftar cuma 2 menit, langsung bisa main. Sweet Bonanza favorit aku!",
        verified: true
      },
      {
        name: "Agus Setiawan",
        location: "Semarang",
        rating: 5,
        date: "2 minggu yang lalu",
        comment: "Sistem keamanannya bagus, ada verifikasi dua faktor. Saya udah deposit puluhan kali, withdraw juga lancar. LECI123 recommended buat pemain pemula maupun pro.",
        verified: true
      }
    ]
  },
  en: {
    title: "What Our Players Say",
    subtitle: "Thousands of members are satisfied with LECI123 services",
    aggregateRating: {
      ratingValue: 4.9,
      reviewCount: 12847,
      bestRating: 5,
      worstRating: 1
    },
    items: [
      {
        name: "Budi Santoso",
        location: "Jakarta",
        rating: 5,
        date: "2 days ago",
        comment: "Withdraw was very fast, only 3 minutes and money was already in my BCA account. Playing at LECI123 is really comfortable, customer service is friendly and responsive.",
        verified: true
      },
      {
        name: "Andi Pratama",
        location: "Surabaya",
        rating: 5,
        date: "1 week ago",
        comment: "Been playing at LECI123 for almost a year, never had any problems. RTP is high, my Gates of Olympus jackpot reached 250 million. Thank you LECI123!",
        verified: true
      },
      {
        name: "Sari Wulandari",
        location: "Bandung",
        rating: 5,
        date: "3 days ago",
        comment: "I was hesitant at first to play online slots, but LECI123 turned out to be trustworthy. Deposit via DANA goes directly, no hassle. The newbie bonus is also great.",
        verified: true
      },
      {
        name: "Rizki Hidayat",
        location: "Medan",
        rating: 4,
        date: "5 days ago",
        comment: "Lots of game choices, from Pragmatic, PG Soft to Habanero, all available. The 24-hour live chat really helps when playing late at night.",
        verified: true
      },
      {
        name: "Dewi Lestari",
        location: "Yogyakarta",
        rating: 5,
        date: "1 week ago",
        comment: "Really like the LECI123 interface, simple and easy to use. Registration only takes 2 minutes, can play immediately. Sweet Bonanza is my favorite!",
        verified: true
      },
      {
        name: "Agus Setiawan",
        location: "Semarang",
        rating: 5,
        date: "2 weeks ago",
        comment: "The security system is good, with two-factor authentication. I've deposited dozens of times, withdrawals are also smooth. LECI123 is recommended for both beginner and pro players.",
        verified: true
      }
    ]
  }
};

